import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchEmployerSubscriptionsTopUp, fetchEmployerSubscriptionsTopUpPaymentCheck } from "./EmployerSubscriptionTopUpAPI";


const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const fetchEmployerSubscriptionsTopUpAsync = createAsyncThunk(
    "EmployerSubscriptionsTopUp/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchEmployerSubscriptionsTopUp();

            const resp = data.response;
            // console.log("data's response", data.response);
            return resp;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const fetchEmployerSubscriptionsTopUpPaymentCheckAsync = createAsyncThunk(
    "EmployerSubscriptionsTopUpPaymentCheck/fetch",
    async (uuid, { rejectWithValue }) => {
        try {
            const data = await fetchEmployerSubscriptionsTopUpPaymentCheck(uuid);

            const resp = data.response;
            // console.log("data's response", data.response);
            return resp;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

const EmployerSubscriptionsTopUpSlice = createSlice({
    name: "EmployerSubscriptionsTopUp",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployerSubscriptionsTopUpAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchEmployerSubscriptionsTopUpAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                // console.log("DAta", action.payload)
                state.error = null;
            })
            .addCase(fetchEmployerSubscriptionsTopUpAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            .addCase(fetchEmployerSubscriptionsTopUpPaymentCheckAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchEmployerSubscriptionsTopUpPaymentCheckAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                // console.log("DAta", action.payload)
                state.error = null;
            })
            .addCase(fetchEmployerSubscriptionsTopUpPaymentCheckAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })

    },
});

export const selectEmployerSubscriptionsTopUp = (state) => state.employerSubscriptionsTopUp.data;
// export const selectEmployerSubscriptionsStatus = (state) => state.employerSubscriptions;

export default EmployerSubscriptionsTopUpSlice.reducer;